import * as ActionPartnerTypes from 'actions/partner';

const defaultState = [];

export default function accounts(state = defaultState, action) {
  switch (action.type) {
    case ActionPartnerTypes.ACCOUNTS_RECEIVE:
      return action.payload.accounts;
    default:
      return state;
  }
}
